import { render, staticRenderFns } from "./BranchSelectorModal.vue?vue&type=template&id=3dac9cdc&scoped=true"
import script from "./BranchSelectorModal.vue?vue&type=script&lang=js"
export * from "./BranchSelectorModal.vue?vue&type=script&lang=js"
import style0 from "./BranchSelectorModal.vue?vue&type=style&index=0&id=3dac9cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac9cdc",
  null
  
)

export default component.exports